import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function IranianToiletIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M11.4111 10.9326C12.6884 9.25426 14.1281 8.68 15.5029 8.8916C16.831 9.09612 17.968 10.0158 18.7305 11.0479C19.3571 11.8961 19.4533 12.9515 19.3496 13.8848L18.5771 20.8291C18.5175 21.3664 18.3407 21.955 17.918 22.4141C16.8229 23.6033 15.4491 23.8797 14.2646 23.665C13.1151 23.4566 12.0801 22.7711 11.6494 21.9463C11.5377 21.7323 11.4951 21.5123 11.4688 21.3467C11.1353 19.2483 10.8085 15.9396 10.6338 14.0381C10.5369 12.9834 10.7204 11.8404 11.4111 10.9326Z"
        stroke="currentColor"
      />
      <path
        d="M15 5.25C18.2481 5.25 20.3389 6.65505 21.5967 8.20508C22.2178 8.97055 22.632 9.76427 22.8887 10.4297C23.1261 11.0453 23.2567 11.6271 23.249 12H23.25V19.5C23.25 20.4665 22.4665 21.25 21.5 21.25H21C20.9382 21.25 20.8655 21.2736 20.7881 21.3447C20.7071 21.4194 20.6374 21.5333 20.6064 21.6631C20.396 22.5481 19.9224 23.5756 19.0137 24.3848C18.0929 25.2045 16.7818 25.75 15 25.75C13.2182 25.75 11.9071 25.2045 10.9863 24.3848C10.0776 23.5756 9.60404 22.5481 9.39355 21.6631C9.3626 21.5333 9.29292 21.4194 9.21191 21.3447C9.13452 21.2736 9.06177 21.25 9 21.25H8.5C7.5335 21.25 6.75 20.4665 6.75 19.5V11.9658L6.75293 11.9316C6.84955 10.87 7.3787 9.2121 8.65137 7.80859C9.94794 6.37875 11.9843 5.25 15 5.25Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <circle cx="15" cy="13" r="2" fill="currentColor" />
    </AmenitySvg>
  );
}
